// extracted by mini-css-extract-plugin
export default {"action-btn":"AgeConfirmation--action-btn--rYtJp","actionBtn":"AgeConfirmation--action-btn--rYtJp","datepicker":"AgeConfirmation--datepicker--lZz0w"};